<template>
  <div>
    <section class="bg content">
    <ul id="galerie">
      <li
        v-for="(post, index) in posts"
        :key="index"
        @click="gotoUrl(post.permalink)"
        :style="index == 24 ? 'display:none' : ''"
      >
        <img
          :src="
            post.media_type == 'VIDEO' ? post.thumbnail_url : post.media_url
          "
          alt=""
        />
        <div class="over">{{ post.caption }}</div>
      </li>
    </ul>
  </section>
    <section class="bg content">
      <div class="description text-large">
        <p>Maison Magenta est une galerie d’antiquités, d’arts décoratifs et d’art contemporain à Lyon.</p>
        <p>Nous sélectionnons des pièces singulières du XVIIIe au XXe siècle — cristaux, verreries, mobilier, miroirs, bronzes et objets de collection — choisies pour leur qualité, leur histoire et leur présence.</p>
        <p>Chaque objet porte la trace d’un savoir-faire, d’une époque et d’un regard. Notre sélection s’adresse aux collectionneurs, amateurs d’art, architectes d’intérieur, décorateurs et professionnels en quête de pièces de caractère pour des intérieurs raffinés.</p>
        <p>Le nom Maison Magenta rend hommage à cette couleur emblématique née dans l’univers de la soierie lyonnaise au XIXe siècle : audacieuse, élégante et intemporelle.</p>
        <p>La galerie accueille également des expositions renouvelées tous les trois mois, créant un dialogue entre patrimoine, arts décoratifs et création contemporaine. Pour rester informé de notre programmation, inscrivez-vous à nos newsletters (voir l’onglet « <a href="/expositions">Expositions</a> »).</p>
      </div>
    </section>
    <section id="store" class="bg content">
      <div id="map">
        <iframe
          title="Google Map : 17 Place Maréchal Lyautey 69006 LYON, FRANCE"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11132.630108531872!2d4.835795490505723!3d45.76803318097574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4eaf739d5908d%3A0x9d65f66e16d1a46d!2s17%20Pl.%20Mar%C3%A9chal%20Lyautey%2C%2069006%20Lyon!5e0!3m2!1sfr!2sfr!4v1737823996624!5m2!1sfr!2sfr"
          width="100%"
          height="100%"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        >
        </iframe>
      </div>
      <div id="hours">
        <address>
          <p class="h1">Adresse</p>
          <h2 class="h2">17 Place Maréchal Lyautey<br />69006 LYON, FRANCE</h2>
        </address>
        <p class="h1">Horaires d'ouverture</p>
        <ul>
          <li><span>Lundi</span><span>15:00–18:00</span></li>
          <li><span>Mercredi</span><span>15:00–18:30</span></li>
          <li><span>Jeudi</span><span>10:30–13:00, 15:00–19:00</span></li>
          <li><span>Vendredi</span><span>10:30–13:00, 15:00–19:00</span></li>
          <li><span>Samedi</span><span>10:30–12:30, 14:30–17:00</span></li>
          <li>* Mardi/Dimanche Sur RDV</li>
        </ul>
      </div>
    </section>
  </div>
  
  
</template>

<script>
import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      posts: [],
    };
  },
  mounted() {
    this.getJson();
  },
  methods: {
    async getJson() {
      const response = await axios.get(
        "https://graph.instagram.com/me/media?fields=id,caption,media_url,media_type,permalink,thumbnail_url&access_token=EAARdWYCV99sBOwrclaAth9BZCFLiCo8m8HxVZAZC8cr3dSYBYn4WgWZCszJ1w4M1vi86P9SgMxdP35cscy81kSFtk9UZBTl7LuiP0xisZCWHl1EHDfOGN6PnBrMFZCZBOSQumEpHbuUNz0UwrPr83nZC5nfwXmbHq8ndUpqJj9fhlNGHVtwNu2sr51EAZAz7St0al3aygZC1sAEmAsJXjXkZCfACIeVJagZA7tgpfSxLZBVe5G05ZBamqT7D6Y4a8UWTqOfJCAZD"
      );
      this.posts = response.data.data;
    },
    gotoUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss">


</style>